function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import omit from 'lodash/omit';
import momentPropTypes from 'react-moment-proptypes';
import DatePicker from '../DatePicker';
import FormControlLabel from '../FormControlLabel';
export var FormControlDateRange = function FormControlDateRange(_ref) {
  var label = _ref.label,
      labelPlacement = _ref.labelPlacement,
      leftAdornment = _ref.leftAdornment,
      onChange = _ref.onChange,
      width = _ref.width,
      error = _ref.error,
      rest = _objectWithoutProperties(_ref, ["label", "labelPlacement", "leftAdornment", "onChange", "width", "error"]);

  return /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(DatePicker, Object.assign({
      onDatesChange: onChange,
      buttonProps: {
        style: {
          width: width,
          justifyContent: 'space-between'
        }
      }
    }, omit(rest, ['name', 'renderFormControl']))),
    label: label,
    labelPlacement: labelPlacement,
    leftAdornment: leftAdornment,
    gutterBottom: true,
    error: error
  });
};
export var propTypes = {
  label: PropTypes.string,
  labelPlacement: PropTypes.string,
  startDate: momentPropTypes.momentObj,
  endDate: momentPropTypes.momentObj
};
FormControlDateRange.propTypes = propTypes;
FormControlDateRange.defaultProps = {
  labelPlacement: 'top'
};
export default FormControlDateRange;